module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct_no_cn"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page303",
      "title": "303"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Text/Contents#Fig"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Figures Mentioned in "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The Boys in the Cave")])])])]), _vm._v(" "), _c('p', {
    staticClass: "A"
  }, [_vm._v("The Wild Boar Soccer team")]), _vm._v(" "), _c('ul', {
    staticClass: "Bullet"
  }, [_c('li', {
    staticClass: "BL"
  }, [_vm._v("“Note” Prachak Sutham: Fourteen, tall for his age, and perhaps the most mechanically inclined of the boys. His father works at a local garage.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("“Tern” Natthawut Thakhamsong: Fourteen, defender. Very close to his parents and grandparents.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("“Nick” Phiphat Phothi: Fifteen, cousin and neighbor to Night. Had only joined the team a couple of weeks before they went missing.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("“Night” Peeraphat Somphiangchai: Sixteen, celebrated his birthday the day the boys became trapped in the cave, June 23. Cousin and neighbor to Nick. Joined the Wild Boars only two months earlier.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page304",
      "title": "304"
    }
  }), _vm._v("“Mick” Phanumas Saengdee: Twelve, goes to the Mae Sai Prasitsart School. Despite being chubby-cheeked, considered one of the better young players.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("“Adul” Adul Samon: Fourteen, originally from Myanmar. He was stateless and lives at the Grace Baptist Church.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("“Biw” Ekkarat Wongsukchan: Fourteen, team goalie. Notorious doodler and snacker in class. He drove the moped from which Coach Ek filmed as the boys rode up to the cave.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("“Dom” Duangphet Phromthep: Thirteen, family owns an amulet shop in Mae Sai, also a 13-and-under captain.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("“Coach Ek” Coach Ek Eakapol Jantawong: Twenty-four, coach of the 13-and-under “Wild Boar” squad. A former Buddhist monk and part of a stateless minority in Thailand.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("“Tee” Phonchai Khamluang: Sixteen (fifteen at the time the boys were trapped). An outgoing team captain.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("“Titan” Titan Chanin Viboonrungruang: Eleven, youngest member of team, had played soccer for four years. Very close to Coach Ek.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("“Pong” Somphong Jaiwong: Thirteen, a natural athlete, had always dreamed of playing for the Thai national team.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("“Mark” Mongkhon Boonpiam: Thirteen, one of the smaller boys on the squad. Was worried about missing exams during the rescue.")])]), _vm._v(" "), _c('p', {
    staticClass: "A"
  }, [_vm._v("British Cave Rescue Council Team")]), _vm._v(" "), _c('ul', {
    staticClass: "Bullet"
  }, [_c('li', {
    staticClass: "BL"
  }, [_vm._v("Rick Stanton: British cave diver who arrived in Thailand with John Vollanthen on June 27. The former firefighter and Vollanthen were the two-man team who located the boys in Chamber Nine. Was ultimately part of the thirteen-diver team that rescued the boys. His girlfriend is a Thai woman from Chiang Rai.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page305",
      "title": "305"
    }
  }), _vm._v("John Vollanthen: British cave diver who arrived in Thailand on June 27. He’s a member of the two-man team, along with Stanton, that located the boys in Chamber Nine. Father of a tween boy and a Boy Scout troop leader, he owns a small IT consultancy. Was ultimately part of the thirteen-diver team that rescued the boys.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Chris Jewell: World-class British cave diver, works in IT in Sommerset. Was part of the thirteen-diver team that rescued the boys.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Jason Mallison: British cave diver who brought out five boys. Works as a rope-access technician. Was part of the thirteen-diver team that rescued the boys. Mallinson hauled four of the boys and Coach Ek to safety.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Jim Warny: Belgian/Irish support diver, positioned in Chamber Six after Karadzic became ill.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Josh Bratchley: British support diver positioned in Chamber Five alongside Connor Roe.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Connor Roe: British support diver. Positioned in Chamber Five alongside Bratchley.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Bill Whitehouse: vice chair of the British Cave Rescue Council.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Gary Mitchell: Team controller for British divers in Thailand. Also liaised with Thais.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Martin Ellis: Published surveys and descriptions of Thai caves, including Tham Luang.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Rob Harper: British veterinarian and frequent caving partner to Vern Unsworth. Harper served as the liaison between the BCRC and Unsworth.")])]), _vm._v(" "), _c('p', {
    staticClass: "A"
  }, [_vm._v("“Euro-Divers”")]), _vm._v(" "), _c('ul', {
    staticClass: "Bullet"
  }, [_c('li', {
    staticClass: "BL"
  }, [_vm._v("Claus Rasmussen: Originally from Denmark. Father of three, head of “Euro-diver” team and cave diving instructor "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page306",
      "title": "306"
    }
  }), _vm._v("at Phuket’s Blue Label Diving. Posted in Chamber Eight with Mikko Paasi during the rescue.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Mikko Paasi: Originally from Finland. Father of two. Diving instructor posted in Chamber Eight during the rescue alongside Rasmussen.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Ivan Karadzic: Danish, diving instructor now based in Koh Tao, Thailand. Was positioned in Chamber Six with Eric Brown.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Eric Brown: Canadian dive instructor based in Koh Tao, Thailand. Was positioned in Chamber Six with Karadzic.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Ben Reymenants: First foreign diver at the cave, was there late on June 26. He put in more guideline than anyone other than Stanton and Vollanthen. Cave diving instructor at Phuket’s Blue Label Diving.")])]), _vm._v(" "), _c('p', {
    staticClass: "A"
  }, [_vm._v("Thai Officials")]), _vm._v(" "), _c('ul', {
    staticClass: "Bullet"
  }, [_c('li', {
    staticClass: "BL"
  }, [_vm._v("Colonel Singhanat Losuya: Deputy commander of the of Thai Thirty-seventh Military District, Chiang Rai. Worked closely with Thanet Natisri. He played a critical role in compelling Thai leadership to heed warnings of foreign divers’ plans.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Captain Padcharapon Sukpang: Thai Thirty-seventh Military District, Chiang Rai. First military officer in the cave. Saw the boys’ names and the handprints on the wall.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Damrong Hangpakdeeneeyom: Head park ranger at Tham Luang cave.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Kamon Kunngamkwamdee (Lak): One of the first rescuers on scene, joined Vernon Unsworth.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Ruengrit Changkwanyuen: GM regional manager based in Bangkok. Cave diver who assisted SEALs during ther first few days and helped coordinate dive efforts until June 3.")])]), _vm._v(" "), _c('p', {
    staticClass: "A"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page307",
      "title": "307"
    }
  }), _vm._v("United States Air Force (USAF)")]), _vm._v(" "), _c('ul', {
    staticClass: "Bullet"
  }, [_c('li', {
    staticClass: "BL"
  }, [_vm._v("Major Charlie Hodges: U.S. Air Force, 353rd Special Operations Group. Leader of the U.S. team at Thai cave.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Master Sergeant Derek Anderson: 353rd Special Operations Group, Hodges’ head of operations. He was largely responsible for drawing up the details of the actual rescue plan.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Captain Mitch Torrel: 353rd Special Operations Group, commanded USAF operations in Chamber Three, including medics.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page308",
      "title": "308"
    }
  }), _vm._v("Sergeant Sean Hopper: 353rd Special Operations Group, pararescuer and ropes specialist, posted in Chamber Two.")])]), _vm._v(" "), _c('p', {
    staticClass: "A"
  }, [_vm._v("Australian Doctors")]), _vm._v(" "), _c('ul', {
    staticClass: "Bullet"
  }, [_c('li', {
    staticClass: "BL"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page309",
      "title": "309"
    }
  }), _vm._v("Dr. Richard Harris: Australian anesthesiologist and world-class cave diver. Served as the only doctor on the rescue mission. Arrived July 6.")]), _vm._v(" "), _c('li', {
    staticClass: "BL"
  }, [_vm._v("Dr. Craig Challan: Australian veterinarian, world-class cave diver. Joined Harris in the cave. Arrived July 6.")])]), _vm._v(" "), _c('p', {
    staticClass: "A"
  }, [_vm._v("Swaziland")]), _vm._v(" "), _c('ul', {
    staticClass: "Bullet"
  }, [_c('li', {
    staticClass: "BL"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page310",
      "title": "310"
    }
  }), _vm._v("Mabuyo Magagula: the tweeter who started Elon Musk’s involvement in the cave rescue by tweeting directly at him. Mabuyo had 500 Twitter followers; Musk had 22 million.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7810fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Figures.vue
// module id = 69
// module chunks = 0